import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Menu,
  MenuItem,
  withStyles,
} from '@material-ui/core';

import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../../utils/common';
import BedForm from './Dialog/BedForm';

const errMessage = {
  required: 'required_field',
  invalidField: 'this_field_is_invalid',
};

class Bed extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      rowIndex: null,
      subgroupId: null,
      openMenu: null,
      open: false,
      isChanged: false,
      beds: [],
      data: {
        numberOfBeds: '',
        bedName: '',
        bedTypeId: '',
        patientId: null,
      },
      errorField: {
        numberOfBeds: {
          flag: false,
          msg: '',
        },
      },
    };
  }

  async componentDidMount() {
    console.log('componentDidMount from Bed');
    const { data } = this.props.subGroup.toJS();
    this.initBedData(data.moduleId);
  }

  async initBedData(moduleId) {
    let bedsList = await this.props.bed.getBedsList(moduleId);
    bedsList = (bedsList || []).map((bed) => {
      return {
        id: bed.id,
        bedTypeId: bed.bedTypeId,
        bedName: bed.name,
        isChange: false,
        patientId: bed.patient ? bed.patient.id : null,
      };
    });
    this.setState({ beds: bedsList, subgroupId: moduleId });

    await this.props.bed.getBedType();
  }

  handleFinished = () => {
    const moduleStep = 3;
    const { t } = this.props;
    const { beds, isChanged } = this.state;
    const isChangeData = beds.filter((bed) => bed.isChange === true);
    if (isChangeData.length > 0 || isChanged) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();
          this.props.wizard.setActiveFlow('group');
          this.props.wizard.setActiveStep(moduleStep);
          this.handleSetNavigation(moduleStep);
        }
      });
    } else {
      this.props.wizard.setActiveFlow('group');
      this.props.wizard.setActiveStep(moduleStep);
      this.handleSetNavigation(moduleStep);
    }
  };

  handleBack = () => {
    const moduleStep = 3;
    const { t } = this.props;
    const { beds, isChanged } = this.state;
    const isChangeData = beds.filter((bed) => bed.isChange === true);
    if (isChangeData.length > 0 || isChanged) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();

          this.props.wizard.setActiveStep(moduleStep);
          this.props.wizard.setActiveFlow('group');
          this.handleSetNavigation(moduleStep);
        }
      });
    } else {
      this.props.wizard.setActiveStep(moduleStep);
      this.props.wizard.setActiveFlow('group');
      this.handleSetNavigation(moduleStep);
    }
  };

  handleSave = async () => {
    const { t } = this.props;
    const { beds, subgroupId } = this.state;
    try {
      const data = {
        subgroupId,
        beds,
      };
      const result = await this.props.bed.updateBeds(data);
      if (result.statusCode === 200) {
        this.initBedData(subgroupId);
        this.setState({ isChanged: false });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
      }
    }
  };

  handleDelete = async (index) => {
    const { beds } = this.state;
    const results = beds.filter((data, i) => i !== index);
    this.setState({ beds: results, isChanged: true });
  };

  handleResetData = () => {
    const { subgroupId } = this.state;
    this.initBedData(subgroupId);
    this.setState({ isChanged: false });
  };

  handleChangeInputForm = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  clearErrorField(key) {
    if (key === 'numberOfBeds') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          numberOfBeds: false,
        },
      });
    }
  }

  validate() {
    const { t } = this.props;
    const { data } = this.state;
    let checkNumberOfBeds = !data.numberOfBeds ? true : false;
    let msgForNumberOfBeds = t(errMessage.required);
    if (data.numberOfBeds) {
      const firstNumber = data.numberOfBeds.slice(0, 1);
      if (firstNumber === '0') {
        checkNumberOfBeds = true;
        msgForNumberOfBeds = t(errMessage.invalidField);
      }
    }

    this.setState({
      errorField: {
        numberOfBeds: {
          flag: checkNumberOfBeds,
          msg: msgForNumberOfBeds,
        },
      },
    });

    return !checkNumberOfBeds;
  }

  handleAddMultipleBed = () => {
    const { data } = this.state;
    if (this.validate()) {
      const bedData = [...this.state.beds];
      const numberOfBeds = Number(data.numberOfBeds);
      for (let i = 1; i <= numberOfBeds; i++) {
        let result = {
          bedName: `${data.bedName} ${i}`,
          bedTypeId: data.bedTypeId,
          isChange: true,
          patientId: null,
        };
        bedData.unshift(result);
      }

      this.setState({ beds: bedData, isChanged: true });
      this.handleCloseForm();
    }
  };

  handleAddBed = () => {
    const { data } = this.state;
    const bedData = [...this.state.beds];
    bedData.unshift(data);
    this.setState({ beds: bedData, openMenu: null, isChanged: true });
  };

  handleChange = (e, index) => {
    const { beds } = this.state;
    const { name, value } = e.target;
    const newRows = beds.map((row, i) => {
      if (i === index) {
        return { ...row, [name]: value, isChange: true };
      }
      return row;
    });
    this.setState({ beds: newRows, isChanged: true });
  };

  handleFocus = (index) => {
    this.setState({ rowIndex: index });
  };

  handleUnFocus = () => {
    this.setState({ rowIndex: null });
  };

  handleOpenMenu = async (event) => {
    this.setState({
      openMenu: event.currentTarget,
    });
  };

  handleCloseMenu = () => {
    this.setState({
      openMenu: null,
    });
  };

  handleOpenForm = async () => {
    this.setState({
      open: true,
      openMenu: null,
      data: {
        numberOfBeds: '',
        bedName: '',
        bedTypeId: '',
      },
    });
  };

  handleCloseForm = () => {
    this.setState({
      open: false,
      data: {
        numberOfBeds: '',
        bedName: '',
        bedTypeId: '',
      },
    });
  };

  goToPage = (data) => {
    this.handleSetNavigation(data.wizardStep);
    this.props.wizard.setActiveStep(data.wizardStep);
  };

  handleSetNavigation = (step) => {
    const { navigations } = this.props.wizard.toJS();
    navigations.forEach((nav) => {
      if (nav.wizardPage === 'unit') {
        nav.wizardName = 'wizard_step_unit';
      }
    });
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
  };

  render() {
    const { classes, t } = this.props;
    const { beds, rowIndex } = this.state;
    const { bedType } = this.props.bed.toJS();
    const { navigations } = this.props.wizard.toJS();

    return (
      <div>
        <Grid container>
          <Grid container item sm={12}>
            {(navigations || []).map((nav, i) => (
              <div id={nav.wizardPage} className={classes.nav} key={i} onClick={() => this.goToPage(nav)}>
                {' '}
                {t(`${nav.wizardName}`)}
                {' > '}
              </div>
            ))}
            <div className={classes.activeNav}>{t('wizard_bed')}</div>
          </Grid>
          <Grid container item xs={12} sm={12} md={8}>
            <div className={classes.textHeader}>{t('wizard_bed_of')} </div>
            <div className={classes.textHeaderPrimary}>{navigations[3] ? navigations[3].wizardName : ''}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.wrapButton}>
            <Button
              id='create'
              variant='contained'
              style={{
                backgroundColor: '#009D9A',
                color: '#fff',
                borderRadius: 8,
              }}
              onClick={(e) => this.handleOpenMenu(e)}
            >
              <div style={{ marginRight: 5 }}>
                <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#fff' }}>
                  <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                </svg>
              </div>
              {t('wizard_bed_create')}
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
          <Paper className={classes.paperTable}>
            <div style={{ overflow: 'auto', maxHeight: '543px' }}>
              <Table>
                <TableHead>
                  <TableRow style={{ border: 'none' }}>
                    <CustomTableCell style={{ borderTopLeftRadius: '8px', width: 450 }}>
                      {t('bed_name')}
                    </CustomTableCell>
                    <CustomTableCell style={{ width: 650 }}>{t('bed_type')}</CustomTableCell>
                    <CustomTableCell style={{ borderTopRightRadius: '8px' }}>{t('action')}</CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {beds.length === 0 && (
                    <TableRow style={{ borderTop: '1px solid #B8CFC3' }}>
                      <TableCell style={{ padding: '20px' }} colSpan={12}>
                        <Grid item xs={12} sm={12} style={{ textAlign: 'center', margin: 10 }}>
                          <div
                            style={{
                              justifyContent: 'center',
                              display: 'flex',
                            }}
                          >
                            <svg width='56' height='56' viewBox='0 0 56 56'>
                              <use xlinkHref={`/images/menus-v1.svg#folder`} />
                            </svg>
                          </div>
                          <div style={{ margin: 5 }}>
                            <Typography className={classes.textTitle}>{t('wizard_no_bed')}</Typography>
                          </div>
                          <div style={{ margin: 10 }}>
                            <Typography className={classes.textSubTitle}>{t('wizard_no_bed_detail')}</Typography>
                            <Typography className={classes.textSubTitle}>{t('wizard_pls_create_bed')}</Typography>
                          </div>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  )}
                  {beds.length > 0 &&
                    beds.map((data, i) => (
                      <TableRow key={i}>
                        <CustomTableCell component='th' scope='row'>
                          <TextField
                            id='bedName'
                            name='bedName'
                            variant='outlined'
                            margin='dense'
                            fullWidth
                            value={data.bedName}
                            onChange={(e) => this.handleChange(e, i)}
                            onFocus={() => this.handleFocus(i)}
                            onBlur={() => this.handleUnFocus()}
                            className={classes.textField}
                            InputProps={{
                              className:
                                rowIndex === i
                                  ? classes.input
                                  : data.bedName.length > 0
                                    ? classes.inputNoBorder
                                    : classes.input,
                              readOnly: rowIndex !== i,
                            }}
                          />
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          <TextField
                            select
                            id='bedTypeId'
                            name='bedTypeId'
                            variant='outlined'
                            margin='dense'
                            value={data.bedTypeId || 0}
                            onChange={(e) => this.handleChange(e, i)}
                            className={classes.textField}
                            InputProps={{
                              className: classes.input,
                            }}
                            style={{
                              width: '70%',
                              marginRight: 10,
                            }}
                          >
                            <MenuItem value={0}>{t('wizard_select_bed_type')}</MenuItem>
                            {(bedType || []).map((type) => (
                              <MenuItem fullwidth='true' key={type.id} value={type.id}>
                                {type.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          <Grid container alignItems='center'>
                            <IconButton
                              id={`delete-${data.bedName}`}
                              className={classes.btnIcon}
                              onClick={() => this.handleDelete(i)}
                              disabled={data.patientId ? true : false}
                            >
                              <svg width='24' height='24' viewBox='0 0 16 16'>
                                <use xlinkHref={`/images/menus-v1.svg#trash`} />
                              </svg>
                            </IconButton>
                          </Grid>
                        </CustomTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>

        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Button
              id='back'
              variant='outlined'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={this.handleBack}
              className={classes.btnPrimary}
            >
              {t('back')}
            </Button>
          </div>
          <div style={{ display: 'flex' }}>
            {this.state.isChanged && (
              <Button
                id='reset'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                onClick={this.handleResetData}
                className={classes.btnPrimary}
              >
                {t('wizard_reset_data')}
              </Button>
            )}
            {this.state.isChanged && (
              <Button
                id='save'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                className={classes.btnPrimary}
                onClick={this.handleSave}
              >
                {t('save')}
              </Button>
            )}
            <Button
              id='finish'
              variant='contained'
              color='primary'
              onClick={this.handleFinished}
              className={classes.btnPrimary}
            >
              {t('wizard_finish')}
            </Button>
          </div>
        </Grid>

        <BedForm
          open={this.state.open}
          data={this.state.data}
          errorField={this.state.errorField}
          bedType={bedType}
          handleChange={this.handleChangeInputForm}
          handleCloseForm={this.handleCloseForm}
          handleSubmitForm={this.handleAddMultipleBed}
        />

        <Menu
          id='selectManage'
          anchorEl={this.state.openMenu}
          open={Boolean(this.state.openMenu)}
          onClose={() => this.handleCloseMenu()}
          className={classes.gridMenu}
          disableAutoFocusItem
        >
          <MenuItem fullwidth='true' id='add-bed' onClick={() => this.handleAddBed()}>
            <Typography style={{ display: 'flex' }}>
              <svg width='24' height='24' viewBox='0 0 24 24' style={{ marginRight: 5 }}>
                <use xlinkHref={`/images/menus-v1.svg#bed`} />
              </svg>
              {t('wizard_bed_create')}
            </Typography>
          </MenuItem>
          <MenuItem id='multiple_bed' onClick={() => this.handleOpenForm()}>
            <Typography style={{ display: 'flex' }}>
              <svg width='24' height='24' viewBox='0 0 24 24' style={{ marginRight: 5 }}>
                <use xlinkHref={`/images/menus-v1.svg#multi-bed`} />
              </svg>
              {t('wizard_create_multiple_bed')}
            </Typography>
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: 'rgba(230, 244, 243, 0.5)',
    color: theme.palette.text.header,
    border: 'none',
  },
  body: {
    fontSize: 16,
    borderTop: '1px solid #B8CFC3',
    borderBottom: 'none',
  },
}))(TableCell);

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
  },
  textTitle: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 20,
  },
  textSubTitle: {
    color: '#858585', //theme.palette.text.hint,
    fontWeight: 500,
    fontSize: 16,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'right',
    },
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  paperTable: {
    boxShadow: 'none',
    border: '1px solid #B8CFC3',
    borderRadius: '8px',
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  inputNoBorder: {
    '& fieldset': {
      border: 'none !important',
    },
    color: theme.palette.text.primary,
    height: 40,
  },
  btnIcon: {
    borderRadius: 4,
    padding: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.bg,
    '&:hover': {
      fill: theme.palette.primary.bg,
      backgroundColor: theme.palette.primary.main,
    },
    '&:disabled': {
      fill: theme.palette.disable.main,
      backgroundColor: theme.palette.disable.light,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 5,
    },
  },
  btnIconDisabled: {
    width: 32,
    height: 32,
    display: 'flex',
    backgroundColor: theme.palette.background.light,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    fill: theme.palette.text.hint,
  },
  nav: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    marginRight: 5,
  },
  activeNav: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
});

export const page = inject('wizard', 'bed', 'subGroup')(observer(Bed));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
